<div class="confirm-modal-main confirm-modal-sec">
    <mapfre-modal
        [modalOptions]="confirmModal"
        [hideModal]="hideModal"
        (hideModalOutput)="hideModalAction($event)"
        (click)="hideOnClick($event)">
        <div class="modal-body no-margin-top modal-margin-bottom text-center">
            <div class="margin-top mt16">
                <div>
                    <img src="./assets/img/images/icon-warning-64-black.svg" alt="expired icon" />
                </div>
                <div class="confirm-modal-title margin-top mt16">{{'Are you sure you want to exit?' | translate}}</div>
            </div>
            <div class="margin-top mt16">
                {{ "The form information won’t be saved." }}
            </div>
            
            <hr class="ma-hr-tag">
            <div class="show-btn-order display-right margin-bottom mb16 margin-top mt24">
                <mapfre-button 
                    (click)="onCancel()"
                    additionalClasses="ghost secondary small-btn mr-3 margin-bottom modal-small-btn letter-space-17">
                    {{ "Cancel" | translate }}
                </mapfre-button>
                <mapfre-button 
                    (click)="onExit()"
                    additionalClasses="basic primary small-btn modal-small-btn letter-space-17">
                    {{ "Exit" | translate }}
                </mapfre-button>
                
            </div>
        </div>
    </mapfre-modal>
</div>